import styled from 'styled-components'
import { position } from 'styled-system'

import { Flex } from 'Components/UI/_Legacy'

import {
  LANDING_INLINE_PADDINGS,
  LANDING_MAX_CONTENT_WIDTH_PX,
} from 'Constants/Landing'

export const Container = styled(Flex).attrs({
  pl: LANDING_INLINE_PADDINGS,
  bottom: [50, 60],
  height: [310, 350],
})`
  right: 0;
  width: 100vw;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 11;

  ${position}
`

const imageBreakpoint = () =>
  LANDING_MAX_CONTENT_WIDTH_PX + LANDING_INLINE_PADDINGS[2] * 2

export const Content = styled(Flex)`
  height: 100%;
  width: 100%;
  z-index: 3;

  @media screen and (min-width: ${imageBreakpoint}px) {
    max-width: calc(
      (100vw - ${LANDING_MAX_CONTENT_WIDTH_PX}px) / 2 +
        ${LANDING_MAX_CONTENT_WIDTH_PX}px
    );
    position: absolute;
    right: 0;
  }

  img {
    border-radius: 20px 0 0 20px;
    object-fit: cover;
    object-position: left;
    left: 0;
  }
`
